import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'

const gridFiltersConfig: any = {
    STATUSTYPEFILTER: { prop: null, param: 'STATUSTYPEFILTER', url_param: true },
    TEAMFILTER: { prop: null, param: 'TEAMFILTER', url_param: true },
    USERFILTER: { prop: null, param: 'USERFILTER', url_param: true },
    MELDERFILTER: { prop: null, param: 'MELDERFILTER', url_param: true },
    NRBETRFILTER: { prop: null, param: 'NRBETRFILTER', url_param: true },
}

const initialState = {
    loadAuftragListStatus: 'idle',
    loadAuftragListError: undefined as any,
    loadAuftragListLastArgs: undefined as any,
    loadAuftragStatus: 'idle',
    loadAuftragError: undefined as any,
    saveAuftragStatus: 'idle',
    saveAuftragError: undefined as any,
    deleteAuftragStatus: 'idle',
    deleteAuftragError: undefined as any,
    loadDefaultAuftragPrioStatus: 'idle',
    loadDefaultAuftragPrioError: undefined as any,
    loadDefaultAuftragStatusStatus: 'idle',
    loadDefaultAuftragStatusError: undefined as any,
    loadDefaultAuftragsartStatus: 'idle',
    loadDefaultAuftragsartError: undefined as any,
    loadAuftragStichdatumEnabledStatus: 'idle',
    loadAuftragStichdatumEnabledError: undefined as any,
    loadFlstmKostenstelleStatus: 'idle',
    loadFlstmKostenstelleError: undefined as any,

    auftragList: [] as any[],
    auftragStichdatumEnabled: undefined as any,
    defaultAuftragPrio: undefined as any,
    defaultAuftragsart: undefined as any,
    defaultAuftragStatus: undefined as any,
    flstmKostenstelle: undefined as any,
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragList = createAsyncThunk('auftragSlice/loadAuftragList', async ({ gridFilters, globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragSlice.loadAuftragListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/nurisauftrag/?STATUSTYPE_FILTER=${gridFilters.values.STATUSTYPEFILTER||0}&OBJRANGE_FILTER=globalFilters.objectFilter&TIMEFILTER=globalFilters.fromFilter&TEAM_FILTER=${gridFilters.lookupValues.TEAMFILTER ? Object.values(gridFilters.lookupValues.TEAMFILTER).map((team: any) => team.HDR_ID) : ''}&USER_FILTER=${gridFilters.lookupValues.USERFILTER ? Object.values(gridFilters.lookupValues.USERFILTER).map((user: any) => user.HDR_ID) : ''}${gridFilters.values.NRBETRFILTER ? '&NRBETREFF_FILTER=' + gridFilters.values.NRBETRFILTER : ''}${gridFilters.values.MELDERFILTER ? '&MELDER_FILTER=' + gridFilters.values.MELDERFILTER : ''}`, globalFilters, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragListStatus } = getState().auftragSlice
        return loadAuftragListStatus !== 'pending'
    }
})

export const loadAuftrag = createAsyncThunk('auftragSlice/loadAuftrag', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftrag/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragStatus } = getState().auftragSlice
        return loadAuftragStatus !== 'pending'
    }
})

export const saveAuftrag = createAsyncThunk('auftragSlice/saveAuftrag', async ({ auftrag }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftrag?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisauftrag/${ auftrag?.HDR_ID }/`,
            prepareData(auftrag),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisauftrag/`,
            prepareData(auftrag),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragStatus } = getState().auftragSlice
        return saveAuftragStatus !== 'pending'
    }
})

export const deleteAuftrag = createAsyncThunk('auftragSlice/deleteAuftrag', async ({ selectedIds }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/DeleteAuftrag/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: selectedIds.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragStatus } = getState().auftragSlice
        return deleteAuftragStatus !== 'pending'
    }
})

export const loadDefaultAuftragPrio = createAsyncThunk('auftragSlice/loadDefaultAuftragPrio', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftprio/?action=eql&fields=HDR_ID&DEFAULT=1`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadDefaultAuftragPrioStatus } = getState().auftragSlice
        return loadDefaultAuftragPrioStatus !== 'pending'
    }
})

export const loadDefaultAuftragStatus = createAsyncThunk('auftragSlice/loadDefaultAuftragStatus', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftstatart/?action=eql&fields=HDR_ID,STATUSTYP&DEFAULT=1&STATUSTYP=1`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadDefaultAuftragStatusStatus } = getState().auftragSlice
        return loadDefaultAuftragStatusStatus !== 'pending'
    }
})

export const loadDefaultAuftragsart = createAsyncThunk('auftragSlice/loadDefaultAuftragsart', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftragsart/?action=eql&fields=HDR_ID&DEFAULT=1`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadDefaultAuftragsartStatus } = getState().auftragSlice
        return loadDefaultAuftragsartStatus !== 'pending'
    }
})

export const loadAuftragStichdatumEnabled = createAsyncThunk('auftragSlice/loadAuftragStichdatumEnabled', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/IxHausPlusIni_PlusAuftragStichdatum/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragStichdatumEnabledStatus } = getState().auftragSlice
        return loadAuftragStichdatumEnabledStatus !== 'pending'
    }
})

export const loadFlstmKostenstelle = createAsyncThunk('auftragSlice/loadFlstmKostenstelle', async ({ auftrag }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/vkkonto_sld_bud_total/?action=eql&STAMMID=${auftrag.FLSTMID}&KOSTSTAMMTYP=2&NICHTDIREKTBUCHEN=0`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadFlstmKostenstelleStatus } = getState().auftragSlice
        return loadFlstmKostenstelleStatus !== 'pending'
    }
})

const AuftragSlice = createSlice({
    name: 'auftragSlice',
    initialState,
    reducers: {
        resetloadAuftragListError: (state) => {
            state.loadAuftragListError = undefined
        },
        resetloadAuftrag: (state) => {
            state.formItem = undefined
            state.loadAuftragError = undefined
        },
        resetloadAuftragError: (state) => {
            state.loadAuftragError = undefined
        },
        resetsaveAuftrag: (state) => {
            state.formItem = undefined
            state.saveAuftragError = undefined
        },
        resetsaveAuftragError: (state) => {
            state.saveAuftragError = undefined
        },
        resetdeleteAuftragError: (state) => {
            state.deleteAuftragError = undefined
        },
        resetloadDefaultAuftragPrio: (state) => {
            state.defaultAuftragPrio = undefined
            state.loadDefaultAuftragPrioError = undefined
        },
        resetloadDefaultAuftragPrioError: (state) => {
            state.loadDefaultAuftragPrioError = undefined
        },
        resetloadDefaultAuftragStatus: (state) => {
            state.defaultAuftragStatus = undefined
            state.loadDefaultAuftragStatusError = undefined
        },
        resetloadDefaultAuftragStatusError: (state) => {
            state.loadDefaultAuftragStatusError = undefined
        },
        resetloadDefaultAuftragsart: (state) => {
            state.defaultAuftragsart = undefined
            state.loadDefaultAuftragsartError = undefined
        },
        resetloadDefaultAuftragsartError: (state) => {
            state.loadDefaultAuftragsartError = undefined
        },
        resetloadAuftragStichdatumEnabled: (state) => {
            state.auftragStichdatumEnabled = undefined
            state.loadAuftragStichdatumEnabledError = undefined
        },
        resetloadAuftragStichdatumEnabledError: (state) => {
            state.loadAuftragStichdatumEnabledError = undefined
        },
        resetloadFlstmKostenstelle: (state) => {
            state.flstmKostenstelle = undefined
            state.loadFlstmKostenstelleError = undefined
        },
        resetloadFlstmKostenstelleError: (state) => {
            state.loadFlstmKostenstelleError = undefined
        },
        removeFromAuftragListById: (state, action) => {
            state.auftragList = state.auftragList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragListByIds: (state, action) => {
            state.auftragList = state.auftragList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragListStatus = 'preloaded'
            state.loadAuftragListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragList = []
            state.loadAuftragListStatus = 'idle'
            state.loadAuftragListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragList.pending, (state) => {
            state.loadAuftragListStatus = 'pending'
            state.loadAuftragListError = undefined
        })
        builder.addCase(loadAuftragList.fulfilled, (state, action) => {
            state.loadAuftragListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragListLastArgs = action.payload.args

            {
                state.auftragList = action.payload.data

            }
        })
        builder.addCase(loadAuftragList.rejected, (state, action) => {
            state.loadAuftragListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragListError = action.error.message
            } else {
                state.loadAuftragListError = action.payload
            }
        })

        builder.addCase(loadAuftrag.pending, (state) => {
            state.loadAuftragStatus = 'pending'
            state.loadAuftragError = undefined
        })
        builder.addCase(loadAuftrag.fulfilled, (state, action) => {
            state.loadAuftragStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragList.push(newItem) }
                else { state.auftragList[i] = { ...state.auftragList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftrag.rejected, (state, action) => {
            state.loadAuftragStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragError = action.error.message
            } else {
                state.loadAuftragError = action.payload
            }
        })

        builder.addCase(saveAuftrag.pending, (state) => {
            state.saveAuftragStatus = 'pending'
            state.saveAuftragError = undefined
        })
        builder.addCase(saveAuftrag.fulfilled, (state, action) => {
            state.saveAuftragStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragList.push(newItem) }
                else { state.auftragList[i] = { ...state.auftragList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftrag.rejected, (state, action) => {
            state.saveAuftragStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragError = action.error.message
            } else {
                state.saveAuftragError = action.payload
            }
        })

        builder.addCase(deleteAuftrag.pending, (state) => {
            state.deleteAuftragStatus = 'pending'
            state.deleteAuftragError = undefined
        })
        builder.addCase(deleteAuftrag.fulfilled, (state, action) => {
            state.deleteAuftragStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragList = state.auftragList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragList = state.auftragList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftrag.rejected, (state, action) => {
            state.deleteAuftragStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragError = action.error.message
            } else {
                state.deleteAuftragError = action.payload
            }
        })

        builder.addCase(loadDefaultAuftragPrio.pending, (state) => {
            state.loadDefaultAuftragPrioStatus = 'pending'
            state.loadDefaultAuftragPrioError = undefined
        })
        builder.addCase(loadDefaultAuftragPrio.fulfilled, (state, action) => {
            state.loadDefaultAuftragPrioStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultAuftragPrio = newItem
            }
        })
        builder.addCase(loadDefaultAuftragPrio.rejected, (state, action) => {
            state.loadDefaultAuftragPrioStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadDefaultAuftragPrioError = action.error.message
            } else {
                state.loadDefaultAuftragPrioError = action.payload
            }
        })

        builder.addCase(loadDefaultAuftragStatus.pending, (state) => {
            state.loadDefaultAuftragStatusStatus = 'pending'
            state.loadDefaultAuftragStatusError = undefined
        })
        builder.addCase(loadDefaultAuftragStatus.fulfilled, (state, action) => {
            state.loadDefaultAuftragStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultAuftragStatus = newItem
            }
        })
        builder.addCase(loadDefaultAuftragStatus.rejected, (state, action) => {
            state.loadDefaultAuftragStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadDefaultAuftragStatusError = action.error.message
            } else {
                state.loadDefaultAuftragStatusError = action.payload
            }
        })

        builder.addCase(loadDefaultAuftragsart.pending, (state) => {
            state.loadDefaultAuftragsartStatus = 'pending'
            state.loadDefaultAuftragsartError = undefined
        })
        builder.addCase(loadDefaultAuftragsart.fulfilled, (state, action) => {
            state.loadDefaultAuftragsartStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultAuftragsart = newItem
            }
        })
        builder.addCase(loadDefaultAuftragsart.rejected, (state, action) => {
            state.loadDefaultAuftragsartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadDefaultAuftragsartError = action.error.message
            } else {
                state.loadDefaultAuftragsartError = action.payload
            }
        })

        builder.addCase(loadAuftragStichdatumEnabled.pending, (state) => {
            state.loadAuftragStichdatumEnabledStatus = 'pending'
            state.loadAuftragStichdatumEnabledError = undefined
        })
        builder.addCase(loadAuftragStichdatumEnabled.fulfilled, (state, action) => {
            state.loadAuftragStichdatumEnabledStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.auftragStichdatumEnabled = newItem
            }
        })
        builder.addCase(loadAuftragStichdatumEnabled.rejected, (state, action) => {
            state.loadAuftragStichdatumEnabledStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragStichdatumEnabledError = action.error.message
            } else {
                state.loadAuftragStichdatumEnabledError = action.payload
            }
        })

        builder.addCase(loadFlstmKostenstelle.pending, (state) => {
            state.loadFlstmKostenstelleStatus = 'pending'
            state.loadFlstmKostenstelleError = undefined
        })
        builder.addCase(loadFlstmKostenstelle.fulfilled, (state, action) => {
            state.loadFlstmKostenstelleStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.flstmKostenstelle = newItem
            }
        })
        builder.addCase(loadFlstmKostenstelle.rejected, (state, action) => {
            state.loadFlstmKostenstelleStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadFlstmKostenstelleError = action.error.message
            } else {
                state.loadFlstmKostenstelleError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragListError,
    resetloadAuftrag,
    resetloadAuftragError,
    resetsaveAuftrag,
    resetsaveAuftragError,
    resetdeleteAuftragError,
    resetloadDefaultAuftragPrio,
    resetloadDefaultAuftragPrioError,
    resetloadDefaultAuftragStatus,
    resetloadDefaultAuftragStatusError,
    resetloadDefaultAuftragsart,
    resetloadDefaultAuftragsartError,
    resetloadAuftragStichdatumEnabled,
    resetloadAuftragStichdatumEnabledError,
    resetloadFlstmKostenstelle,
    resetloadFlstmKostenstelleError,
    removeFromAuftragListById,
    removeFromAuftragListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragSlice.actions
export default AuftragSlice.reducer
